'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _LocalizationManager = require('../../utils/localization/LocalizationManager');

var _LocalizationManager2 = _interopRequireDefault(_LocalizationManager);

var _AdWrapper = require('./AdWrapper.scss');

var _AdWrapper2 = _interopRequireDefault(_AdWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Ad wrapper component
 * @param {Object} props the component props
 * @returns {JSX}
 */
var AdWrapper = function AdWrapper(props) {
  return _react2.default.createElement(
    'div',
    { className: _AdWrapper2.default.wrapper + ' ' + props.className },
    _react2.default.createElement(
      'span',
      { className: _AdWrapper2.default.label },
      _LocalizationManager2.default.get('advertisement')
    ),
    props.children
  );
};

/**
 * propTypes
 * @property {node} children
 */
exports.default = AdWrapper;


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/components/ads/AdWrapper.js
// module id = 153
// module chunks = 35783957827783